/**
 * EverCart wishlist persistence.
 *
 * The theme's wishlist heart (snippets/card-gallery.liquid, class
 * .wishlist-toggle__input) previously had no backing storage at all — it was
 * a checkbox that only ever reflected its own in-page state and reset on
 * every reload (confirmed: no wishlist-related key existed in localStorage
 * or cookies anywhere in the theme prior to this file). This script is the
 * missing persistence layer, not a second wishlist system: it listens to the
 * exact same checkboxes already rendered on every product card site-wide
 * (homepage, catalog, product recommendations, and the wishlist page's own
 * cards) and keeps them in sync with a single localStorage key.
 */
(function () {
  var STORAGE_KEY = 'evercart:wishlist';

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var ids = raw ? JSON.parse(raw) : [];
      return Array.isArray(ids) ? ids.map(String) : [];
    } catch (e) {
      return [];
    }
  }

  function setWishlist(ids) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
    } catch (e) {
      /* localStorage unavailable (private mode / quota) — fail silently, UI still works for this page view */
    }
    updateCount();
    syncWishlistPage();
  }

  function updateCount() {
    var count = getWishlist().length;
    var nodes = document.querySelectorAll('[data-wishlist-count]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = String(count);
      nodes[i].hidden = count === 0;
    }
  }

  function syncCheckboxes() {
    var ids = getWishlist();
    var inputs = document.querySelectorAll('.wishlist-toggle__input[data-product-id]');
    for (var i = 0; i < inputs.length; i++) {
      var pid = inputs[i].getAttribute('data-product-id');
      inputs[i].checked = ids.indexOf(pid) !== -1;
    }
  }

  function syncWishlistPage() {
    var ids = getWishlist();
    var items = document.querySelectorAll('[data-wishlist-item]');
    if (!items.length) return;

    var visibleCount = 0;
    for (var i = 0; i < items.length; i++) {
      var pid = items[i].getAttribute('data-product-id');
      var match = ids.indexOf(pid) !== -1;
      items[i].hidden = !match;
      if (match) visibleCount++;
    }

    var emptyState = document.querySelector('[data-wishlist-empty]');
    var grid = document.querySelector('[data-wishlist-grid]');
    var toolbar = document.querySelector('[data-wishlist-toolbar]');
    if (emptyState) emptyState.hidden = visibleCount > 0;
    if (grid) grid.hidden = visibleCount === 0;
    if (toolbar) {
      toolbar.hidden = visibleCount === 0;
      var countLabel = document.querySelector('[data-wishlist-item-count]');
      if (countLabel) {
        countLabel.textContent = visibleCount === 1 ? '1 item' : visibleCount + ' items';
      }
    }
  }

  function handleChange(event) {
    var input = event.target;
    if (!input || !input.classList || !input.classList.contains('wishlist-toggle__input')) return;
    var pid = input.getAttribute('data-product-id');
    if (!pid) return;

    var ids = getWishlist();
    var index = ids.indexOf(pid);
    if (input.checked && index === -1) {
      ids.push(pid);
    } else if (!input.checked && index !== -1) {
      ids.splice(index, 1);
    }
    setWishlist(ids);
  }

  document.addEventListener('change', handleChange);

  function init() {
    syncCheckboxes();
    updateCount();
    syncWishlistPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
